import React, { Component } from 'react';
import AppBar from './AppBar';
import VirtualizedList from './VirtualizedList';
import { IIFarm, IMe, IFilter } from '../types';
import SearchField from './SearchField';
import Loader from './Loader';
import {searchFarms} from '../helpers'
import FarmListItem from './FarmListItem';
import OrderService from '../ApiClients/OrderService';
import { withParamsAndNavigate } from './Material/ReactRouter';
import { cloneDeep } from 'lodash';

interface IFarmProps {
    params?:any;
    navigate?:any;    
    myInfo?:IMe;
    filters: IFilter;
    handleChangeFilter: Function;
}

interface IFarmState {
    farms?: Array<IIFarm>;
    searchValue: string;
    filteredFarms: Array<IIFarm>;
    loading: boolean;
    filter_id: string;
}

class Farms extends Component<IFarmProps, IFarmState> {
    constructor(props: IFarmProps) {
        super(props);
        this.state = {
            farms: undefined,
            filteredFarms:[],
            searchValue: '',
            loading: true,
            filter_id: "f_farms"
        };
    }

    componentDidMount() {
        this.getFarms();
    }



    getFarms = async () =>{
        let response = await OrderService.getFarms(false);

        if(response !== undefined){
            // Ordenar por id ascendente
            const sortedFarms = Array.isArray(response)
                ? [...response].sort((a: IIFarm, b: IIFarm) => a.id.localeCompare(b.id))
                : response;
            let searchValue = ('searchbar' in this.props.filters[this.state.filter_id])? this.props.filters[this.state.filter_id]['searchbar'] : '';
            
            this.setState({
                filteredFarms: searchFarms(sortedFarms, searchValue),
                farms: sortedFarms,
                searchValue: searchValue,
                loading:false
            })
        }
    }

    renderFarms=()=>{
        if(this.state.loading){
            return(
                <div style={{marginLeft:'50%',marginTop:200}}>
                    <Loader loading={true}/>
                </div>
            );
        }
        else {
            const {filteredFarms} = this.state;
            if(filteredFarms.length == 0)
                return (
                    <div style={{textAlign:'center', padding:50}}>
                        {this.state.searchValue?.length == 0?
                            <p>
                                {`No tiene granjas configuradas para visualizar.`}
                            </p>
                        :
                            <p>
                                {`No existe ninguna granja con el valor de búsqueda aplicado.`}
                            </p>
                        }
                    </div>
                )
            let items = filteredFarms.map((farm) => {
                return {
                    ...farm,
                    onItemClick: () => this.handleItemClick(farm),
                    onInfoClick: () => this.handleInfoClick(farm),
                }
            })
            return(
                <VirtualizedList items={items} RowComponent={FarmListItem} itemSize={130} />
            );
        }
    }

    handleItemClick = (farm: IIFarm) => {
        this.props.navigate(`/granja/${farm.business}/${farm.id}/productos`)
    }

    handleInfoClick = (farm: IIFarm) => {
        this.props.navigate(`/granja/${farm.business}/${farm.id}`)
    }

    handleValueChange = (evt: any) => {
        if(this.state.farms !== undefined) {
            let newFilters = cloneDeep(this.props.filters[this.state.filter_id]);
            newFilters["searchbar"] = evt.target.value;

            this.props.handleChangeFilter(this.state.filter_id, newFilters, false);

            this.setState({ 
                searchValue: evt.target.value,
                filteredFarms: searchFarms(this.state.farms, evt.target.value)
             })
        }
    }

    render() {

        return (
            <AppBar title={'Mis Granjas'} navigate={this.props.navigate}>
                <div style={{ marginTop: 15 }}>
                    <SearchField allowSearch={this.state.loading} value={this.state.searchValue} onValueChange={this.handleValueChange} placeholder="Buscar granja..." />
                </div>
                <div style={{
                    position: 'absolute',
                    top: '65px',
                    left: 0,
                    right: 0,
                    bottom: 0,
                }}>
                {this.renderFarms()}
                </div>
            </AppBar>
        );
    }
}
export default withParamsAndNavigate(Farms);